import {createSvgIcon} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
export type SVGIconComponent = typeof SvgIcon;
import {ReactComponent as FacebookIconSrc} from '../../src/assets/facebook.svg';
import {ReactComponent as GoogleSrc} from '../../src/assets/google.svg';
import {ReactComponent as MicrosoftIconSrc} from '../../src/assets/microsoft.svg';
import {ReactComponent as AadeSrc} from '../../src/assets/aade.svg';
import { ReactComponent as SunSrc } from '../../src/assets/sun.svg';
import { ReactComponent as CloudSrc } from '../../src/assets/cloud.svg';
import { ReactComponent as AirportSrc } from '../../src/assets/airport.svg';
import { ReactComponent as ShipSrc } from '../../src/assets/port.svg';
import { ReactComponent as WordPressSrc } from '../../src/assets/wordpress.svg';
import { ReactComponent as OmekaSrc } from '../../src/assets/omeka.svg';

export const FacebookIcon = createSvgIcon(<FacebookIconSrc/>,'Facebook');
export const GoogleIcon = createSvgIcon(<GoogleSrc/>,'Google');
export const MicrosoftIcon = createSvgIcon(<MicrosoftIconSrc/>,'Microsoft');
export const AaadeIcon = createSvgIcon(<AadeSrc/>,'AADE');

export const SunIcon = createSvgIcon(<SunSrc/>,'Sun');
export const CloudIcon = createSvgIcon(<CloudSrc/>,'Cloud');
export const AirplaneIcon = createSvgIcon(<AirportSrc/>,'Airport');
export const PortIcon = createSvgIcon(<ShipSrc/>,'Port');

export const WordPressIcon = createSvgIcon(<WordPressSrc/>,'WordPress');
export const OmekaIcon = createSvgIcon(<OmekaSrc/>,'Omeka');